var filter = {
	elms: {
	    pageTitle: $('.hero-search-new-content > header > .module-title'),
	    productCategory : $( '.product-page' ).data( 'product-category-name' ),
		clearElms: $('[data-filter-clear]'),
		triggerElms: $('[data-filter-trigger] select'),
		containerElms: $('[data-filter-content]'),
		itemElms: $('[data-category-list]'),
		blockElms: $('[data-filter-block]'),
		blocknavElms: $('[data-filter-blocknav]')
	},
	allProducts_text: null,
	viewAllFilter_text: null,

	// Only for brands page??
	scrolltoNav: function() {
		if (filter.elms.blocknavElms.length > 0) {
			var offsetDiff = 20;

			if (windowWidth >= desktop) {
				offsetDiff = 95;
			}

			$('html,body').animate({
				scrollTop: filter.elms.blocknavElms.offset().top - offsetDiff
			}, 1000);
		}
	},

	applyCategoryFilter: function( filterValue ) {
		//console.log( "filter: applyCategoryFilter", filterValue );

	    // this should be run only on products/non-eu pages, not brand filter
		if (filter.elms.productCategory)
		    window.location.href = productPage.productBaseUrl + filter.elms.productCategory + '/' + filterValue;

		$('.no-matches').removeClass('show');

		var filterType;
		// var filterValue; // no need to redeclare

		if ($(this).attr('data-filter-triggerLi')) {

		    filterType = $(this).closest('.searchDd-category').data('filter-type');
		    //console.log(filterType);
			filterValue = $.trim($(this).attr('data-filter-triggerLi'));

			if ( $('.searchDd-main').hasClass('open') )
				$('.searchDd-main').trigger('click');

			var catSelected = $(this).text();
			$('.searchDd-main').text(catSelected);
			if ($('#allProducts').length) {
				filter.elms.pageTitle.text(catSelected);
			}

			if ($('.searchDd-clear').hasClass('hide')) {
				$('.searchDd-clear').removeClass('hide');
			}
		} else {

			// this throws an error in jQuery, also seems to be redundant (onFilterChange() already trims the value and sends it to this function):
			// filterValue = $.trim($(this).val());

		}

		if (filterValue !== 'clearSelect') {

			// Hide the title that says all items are displaying, because we are about to filter
			$('.title-all-items').addClass('hide');

			// filter items and hide and show on match
			// filter.elms.itemElms.filter(':not([data-category-list*=",' + filterValue + ',"])').addClass('filter-hidden').hide();
			// filter.elms.itemElms.filter('[data-category-list*=",' + filterValue + ',"]').removeClass('filter-hidden').show();

			var $item;
			var itemCategoryList;
			var hiddenCount = 0;

			filter.elms.itemElms.each(function(){
				$item = $( this );
				var itemCategoryList = $item.attr( 'data-category-list' );
				if ( itemCategoryList.match( new RegExp( '(?:^|,)' + filterValue + '(?:,|$)' ) ) ) {
					$item.removeClass( 'filter-hidden' ).show();
				} else {
				    $item.addClass('filter-hidden').hide();
				    hiddenCount++;
				}
			});


			if (hiddenCount == filter.elms.itemElms.length) {
			    //console.log('There are no visible brands');
			    $('.no-matches').addClass('show');
			}

			// If blocks (on brands page) toggle the blocks
			if (filter.elms.blockElms) {
				filter.updateBlockDisplay();
			}
			if (filter.elms.blocknavElms) {
				filter.scrolltoNav();
			}

			search.clearSearchInput();

			$.publish('/filters/updated', [{}]);
		}
	},

	clearFilters: function(event) {
		event.preventDefault();

		// Remove no matches message
		$('.no-matches').removeClass('show');
		$('.title-all-items').removeClass('hide');

		// remove hide from all elements
		filter.elms.itemElms.removeClass('filter-hidden').show();

		// if blocks toggleBlocks
		if (filter.elms.blockElms) {
			filter.updateBlockDisplay();
		}

		// reset triggers to default state
		if (isTouch) {
			filter.elms.triggerElms.find(':selected').removeAttr('selected');
			filter.elms.triggerElms.find('[value="clearSelect"]').attr('selected', 'selected');
		} else {
			filter.elms.triggerElms.dropkick('select', 0);
		}

		$.publish('/filters/updated', [{}]);

	},

	updateBlockDisplay: function() {
		for (var i = 0, l = filter.elms.blockElms.length; i < l; i++) {
			var block = filter.elms.blockElms.eq(i);
			var items = block.find('[data-category-list]:not(.filter-hidden)');

			// .empty to toggle anchornav
			if (items.length > 0) {
				block.show();
				filter.elms.blocknavElms.find('a[href="#' + block.attr('id') + '"]').removeClass('empty');
			} else {
				block.hide();
				filter.elms.blocknavElms.find('a[href="#' + block.attr('id') + '"]').addClass('empty');
			}
		}
	},

	initSpecialDd: function() {
		//console.log( 'filter: initSpecialDd' );

		var ddTrigger = $('.searchDd-main');
		var ddList = $('.searchDd-list');
		var ddSubTrigger = $('.searchDd-category');
		var ddSubList = $('.searchDd-sublist');
		var ddSubListTrigger = ddSubList.find( '[data-product-search-value]' );
		var clearTrigger = $('.searchDd-clear');

		// Set Special Dropdown Text
		if ( productPage.productSearchValue ) {

			var filterText = ddSubListTrigger.filter( '[data-product-search-value=' + productPage.productSearchValue + ']' ).text();
			filter.setSpecialDdText(filterText);
		}


		// Set Scrollbar
		ddSubList.mCustomScrollbar( {
			axis:'y',
			theme: 'light-2'
		} );

		// Add Event Listeners
		clearTrigger.on( 'click', onClearTriggerClick );
		ddTrigger.on( 'click', onDdTriggerClick );
		ddSubTrigger.on('click', onDdSubTriggerClick );
		ddSubListTrigger.on( 'click', onDdSubListTriggerClick );
		$( document ).on( 'click', onDocumentClick );

		// Event Listeners
		function onClearTriggerClick( e ) {
			//console.log( 'filter: onClearTriggerClick' );

			ddTrigger.trigger( 'click' );

			window.location.href = productPage.productBaseUrl;

		}

		function onDdTriggerClick( e ) {
			//console.log( 'filter: onDdTriggerClick' );

			$(this).toggleClass('open');
			ddList.toggleClass('open');

			setTimeout(function(){
				filter.undoSpecialDd();
			}, 100);

		}

		function onDdSubTriggerClick( e ) {
			//console.log( 'filter: onDdSubTriggerClick' );

			if (windowWidth <= tabletWide) {

				$(this).closest(ddSubTrigger).toggleClass('open');
				$(this).closest(ddSubTrigger).siblings('.searchDd-category.open').removeClass('open').find(ddSubList).slideUp();
				$(this).closest(ddSubTrigger).find(ddSubList).slideToggle();
			}

		}

		function onDdSubListTriggerClick( e ) {
			//console.log( 'filter: onDdSubListTriggerClick' );

			var selectedEl = $( this );

			var filterType = selectedEl.closest( '.searchDd-category' ).data( 'product-search-type' );
			var filterValue = $.trim( selectedEl.data( 'product-search-value' ) );
			var filterText = selectedEl.text();

			filter.setSpecialDdText( filterText );

			window.location.href = productPage.productBaseUrl +  filterType + '/' + filterValue;

		}

		function onDocumentClick( e ) {
			//console.log( 'filter: onDocumentClick' );

			if(!$(e.target).closest('#searchDd').length) {
				if (ddTrigger.hasClass('open')) {
			    ddTrigger.removeClass('open');
					ddList.removeClass('open');
					filter.undoSpecialDd();
				}
		  }
		}
	},

	undoSpecialDd: function() {
		$('.searchDd-category').removeClass('open');
		$('.searchDd-sublist').slideUp();
		setTimeout(function(){
			$('.searchDd-sublist').removeAttr('style');
		},500);
	},

	setSpecialDdText: function( filterText ) {
		//console.log( 'filter: setSpecialDdText', filterText );

		if ( filterText ) {

			// Close the Dropdown if Open
			if ( $('.searchDd-main').hasClass('open') )
				$('.searchDd-main').trigger( 'click' );

			// Set the Dropdown Text
			$( '.searchDd-main' ).text( filterText );

			// Show the Option to Reset the Dropdown
			if ( $( '.searchDd-clear' ).hasClass( 'hide' ) )
				$( '.searchDd-clear' ).removeClass( 'hide' );

		}

	},

	init: function() {
		//console.log( 'filter: init' );

		if (filter.elms.triggerElms && filter.elms.containerElms) {

			// if elements are present init events
			filter.elms.clearElms.on('click', filter.clearFilters);
			filter.elms.triggerElms.on('change', filter.onFilterChange );

            
			// if there's a predefined value on the filter (user is back to page with an active filter), apply filter (by dispatching change event)
		    // this should only be run on the eu brands page			
			if (filter.elms.triggerElms.length && filter.elms.triggerElms[0].value != 'clearSelect' && !filter.elms.productCategory) {
				filter.elms.triggerElms.change();
			}
		}

		// Init Special Dropdown if Applicable
		if ( $( '.searchDd-main' ).length )
		    filter.initSpecialDd();
	},

	// ----- EVENT LISTENERS ----- //
	onFilterChange: function( e ) {
		//console.log( 'filter: onFilterChange' );

		var selectedEl = $( this );

		var filterValue = $.trim( selectedEl.val() );
		filter.applyCategoryFilter( filterValue );

		if ($('.page-products-new').length || $('.page-products').length) {
			filter.allProducts_text = filter.elms.pageTitle.text();
			filter.viewAllFilter_text = $('.searchDd-main').text();
		}

	}
};